import { Action } from '@ngrx/store';
import {Group} from '../../models/group';
import * as actions from '../actions';


export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: Group;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: {} as Group
};

export function reducer(state = initialState, action: actions.GroupDetailActions): State {
  switch (action.type) {
    case actions.GroupDetailActionTypes.GetGroupDetails:
      return {...state, Loaded: false, Loading: true};
    case actions.GroupDetailActionTypes.LoadGroupDetails:
      return {...state, Loaded: true, Loading: false, entities: action.payload };
    default:
      return state;
  }
}
